import { jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from "@emotion/react";
import useThemeProps from "./useThemeProps.mjs";
import Box from "./Box.mjs";
import Details from "./Details.mjs";
function DetailsBox(props) {
  useTheme();
  props = useThemeProps({
    props,
    name: "DetailsBox"
  });
  let {
    color,
    components = {},
    ...restProps
  } = props;
  return /* @__PURE__ */jsx(Details, {
    as: Box,
    color,
    style: {
      [["&.wsui-is-expanded", "&:has(.wsui-details-summary-toggle.wsui-is-interactive:hover)", "&:has(.wsui-details-summary-toggle.wsui-is-interactive:focus-visible)"]]: {
        backgroundColor: color ? [color, "hover"] : void 0
      }
    },
    components: {
      SummaryToggleIcon: {
        color: color ? [color, "text"] : "primary",
        size: 7.5
      },
      ...components
    },
    ...restProps
  });
}
export { DetailsBox as default };